var _a, _b;
import { __assign } from "tslib";
import { reduxKey } from './constants';
import { EmoteStreamType } from './types';
import { init, initDone, initDoneAlready, switchStream, initStreamDone, streamLoadMore, streamLoadDone, } from './actionCreators';
import { handleActions } from 'redux-actions';
var actionHandlers = handleActions((_a = {},
    _a[init.toString()] = function (state) { return (__assign(__assign({}, state), { isLoadingStream: true, activeStream: EmoteStreamType.OFFICIAL })); },
    _a[initDone.toString()] = function (state, action) { return (__assign(__assign({}, state), { isLoadingStream: false, isInitialized: true, officialEmotes: action.payload.result })); },
    _a[initDoneAlready.toString()] = function (state) { return (__assign(__assign({}, state), { isLoadingStream: false })); },
    _a[switchStream.toString()] = function (state, action) { return (__assign(__assign({}, state), { isLoadingStream: true, cachedSearchQuery: action.payload.searchQuery, cachedSearchType: action.payload.searchType })); },
    _a[initStreamDone.toString()] = function (state, action) {
        var _a, _b;
        if (action.payload.streamType === EmoteStreamType.SEARCH) {
            return __assign(__assign({}, state), (_a = { isLoadingStream: false, activeStream: action.payload.streamType }, _a[action.payload.streamType + "Emotes"] = action.payload.result, _a));
        }
        var current = state[action.payload.streamType + "Emotes"];
        return __assign(__assign({}, state), (_b = { isLoadingStream: false, activeStream: action.payload.streamType }, _b[action.payload.streamType + "Emotes"] = current || action.payload.result, _b));
    },
    _a[streamLoadMore.toString()] = function (state) {
        return __assign(__assign({}, state), { isLoadingMore: true });
    },
    _a[streamLoadDone.toString()] = function (state, action) {
        var _a;
        var current = state[action.payload.streamType + "Emotes"];
        var newEmotes = action.payload.result && action.payload.result.results;
        var merged = {
            hasMore: action.payload.result.hasMore,
            nextOffset: action.payload.result.nextOffset,
            results: current && current.results && current.results.concat(newEmotes || []),
        };
        return __assign(__assign({}, state), (_a = { isLoadingMore: false }, _a[action.payload.streamType + "Emotes"] = merged, _a));
    },
    _a), {
    isInitialized: false,
    isLoadingMore: false,
    isLoadingStream: false,
    activeStream: EmoteStreamType.OFFICIAL,
    cachedSearchQuery: '',
    cachedSearchType: 'community',
});
var reducers = (_b = {},
    _b[reduxKey] = actionHandlers,
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map